<template>
  <SoDialog
    v-model="value"
    card-title="Customer thinks their meter is faulty"
    data-testid="faulty-meter-modal"
  >
    <ol class="faulty-meter__ordered-list">
      <li>
        Do they have a <b>traditional meter</b>?
        <div class="mb-4">
          <ul class="faulty-meter__list">
            <li>
              If <b>yes</b>, we can install a smart meter replacement. Follow
              the smart meter interest process.
            </li>
            <li>
              If <b>no</b>, they already have a smart meter! The meter is
              unlikely to be recording incorrect usage, follow the next steps.
            </li>
          </ul>
        </div>
      </li>
      <li>
        Have we had <b>regular reads</b>?
        <div class="mb-4">
          <ul class="faulty-meter__list">
            <li>
              If <b>not</b>, get one now and
              <SoLink
                text="submit it here"
                @click="isSubmitReadingsModalOpen = true"
              />.
            </li>
            <li>
              If <b>yes</b>, check if the usage is regular or if there is a
              spike.
            </li>
          </ul>
        </div>
      </li>
      <li>
        Do they think <b>both meters are faulty</b>?
        <div class="mb-4">
          <ul class="faulty-meter__list">
            <li>
              This is most likely not the case that they've both broken at the
              same time. There might be a new appliance using more energy.
            </li>
          </ul>
        </div>
      </li>
      <li>
        Is the <b>last bill a large bill or a <u>catch up bill</u></b
        >?
        <div class="mb-4">
          <ul class="faulty-meter__list">
            <li>
              Explain this to the customer, the meter isn't faulty! no need to
              escalate.
            </li>
          </ul>
        </div>
      </li>
      <li>
        Ask the customer about <b>appliances</b>.
        <div class="mb-4 ml-4">
          Maybe they installed underfloor heating, started using their heating
          for the first time this year, bought a new fridge freezer, have an old
          fridge freezer that may be faulty, or an extra person moved in
          recently using more energy. Their increased usage is likely just
          increased usage.
        </div>
      </li>
      <li>
        <b>Last resort!</b> Send the <b>Time Test</b> or
        <b>Burns Test</b> canned response.
        <div class="mb-4 ml-4">
          Check the results! If the usage doesn't seem to spike or record while
          nothing is on, tell the customer the meter looks to be running fine
          and it would cost them £120 (per meter) to get a check meter installed
          to see if the meter is faulty if we find out it's working fine.
        </div>
      </li>
    </ol>
  </SoDialog>
  <SubmitReadingsModal v-model="isSubmitReadingsModalOpen" />
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoDialog from "@/components/SoDialog.vue"
  import SoLink from "@/components/SoLink.vue"
  import SubmitReadingsModal from "./SubmitReadingsModal.vue"

  export default defineComponent({
    components: {
      SoDialog,
      SoLink,
      SubmitReadingsModal,
    },
    props: {
      modelValue: {
        type: Boolean,
        default: false,
        required: true,
      },
    },
    emits: ["update:modelValue"],
    data() {
      return {
        isSubmitReadingsModalOpen: false,
      }
    },
    computed: {
      value: {
        get() {
          return this.modelValue
        },
        set(value: boolean) {
          this.$emit("update:modelValue", value)
        },
      },
    },
  })
</script>

<style scoped>
  a {
    color: rgb(var(--v-theme-primary));
    text-decoration: none;
  }

  .faulty-meter__list {
    list-style-position: outside;
    margin-left: 24px;
  }
  .faulty-meter__ordered-list {
    list-style-position: inside;
  }
</style>
